import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './AuthGuard.css';

interface Props {
  children: ReactNode;
}

export function AuthGuard({ children }: Props) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return (
      <div className="auth-loading">
        <div className="auth-loading__spinner" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    const from = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: from === '/login' ? '/' : from }}
      />
    );
  }

  return <>{children}</>;
}
